import { createOptionalCtx } from "@tiny/utils/react/createContext";

const [useDialogContentContext, DialogContentProvider] = createOptionalCtx();

export { useDialogContentContext, DialogContentProvider };
